export default "__VITE_ASSET__DHBm5YFL__"